export class MenuItemModel {
	public Descripcion: string = "";
	public Estado: string = "";
	public EstadosAcciones: any[] = [];
	public IdMenu: number = 0;
	public IdMenuPadre: number = 0;
	public IdSistema: number = 0;
	public Mostrar: boolean = true;
	public Nivel: number = 0;
	public Orden: number = 0;
	public Redireccionar: boolean = false;
	public SubMenu: MenuItemModel[] = [];
	public Icono: string = "";
	public Ruteo: string = "";
	public Seleccionado: boolean = false;

	constructor() { }
}